import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f9fb4350&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fb4350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9fb4350')) {
      api.createRecord('f9fb4350', component.options)
    } else {
      api.reload('f9fb4350', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f9fb4350&scoped=true&", function () {
      api.rerender('f9fb4350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sABbE7qBy3yA/JS/comp/Accordion.vue"
export default component.exports